module.exports = __webpack_public_path__ + "static/rcc-chart-desktop-f5805cc5e6e6d1a98d2475a20d8234a9.png";